import Slide from "../../atoms/slide"

const Service = ({img1, img2, title, desc}) => {
    return (
        <Slide>
            <div className="service">
                <div className="images">
                    <img className="gold" src={img1} alt="Service" />
                    <img className="white" src={img2} alt="Service" />
                </div>
                <div className="title">
                    <h5>{title}</h5>
                    <div className="dash"></div>
                </div>
                <p>{desc}</p>
            </div>
        </Slide>
    )
}

export default Service;